/* @flow */

export {LoadingPage} from './loading-page';
